import React from 'react';
import PropTypes from 'prop-types';
import DocumentShareConstants from 'DocumentShare/DocumentShareConstants';
import SelfServeRecipientBuilderFinishedSideBarLoggedIn from './SelfServeRecipientBuilderFinishedSideBarLoggedIn';
import SelfServeRecipientBuilderFinishedSideBarLoggedOut from './SelfServeRecipientBuilderFinishedSideBarLoggedOut';


const SelfServeRecipientBuilderFinishedSidebar = props => (
  <div className="self-serve-recipient-response-sent-sidebar">
    <div className="self-serve-recipient-response-sent-icon-wrapper">
      <img
        alt="Response sent icon"
        className="self-serve-recipient-response-sent-icon"
        src="/images/self-serve-recipient-builder/response-sent-icon-2x.png"
      />
    </div>
    <div className="self-serve-recipient-response-sent-sidebar-header-wrapper">
      <h1 className="self-serve-recipient-response-sent-sidebar-header">
        {props.accessLevel === DocumentShareConstants.DECLINED_DONE_MODE ? (
          "You've declined to sign!"
        ) : (
          'Your response has been received!'
        )}
      </h1>
    </div>
    <div className="self-serve-recipient-response-sent-sidebar-divider" />
    <div className="self-serve-recipient-response-sent-next-suggestion-wrapper">
      <div className={`self-serve-recipient-response-sent-next-suggestion ${window.User.isLoggedIn ? 'next-suggestion-centered' : ''}`}>
        { window.User.isLoggedIn ?
          'What would you like to do next?' :
          'Create a free account to edit, sign, and share any document'
        }
      </div>
    </div>
    {window.User.isLoggedIn &&
      <SelfServeRecipientBuilderFinishedSideBarLoggedIn />
    }
    {!window.User.isLoggedIn &&
      <SelfServeRecipientBuilderFinishedSideBarLoggedOut shareKey={props.shareKey} />
    }
  </div>
);

SelfServeRecipientBuilderFinishedSidebar.propTypes = {
  accessLevel: PropTypes.string.isRequired,
  shareKey: PropTypes.string.isRequired,
};

export default SelfServeRecipientBuilderFinishedSidebar;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/RecipientFinishedSideBar/index.jsx